var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsaFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ed4c5c;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #428bc1;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115,11.6C103.4,4.3,89.8,0,75.1,0v11.5h39.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.1,23.1h54c-4.2-4.4-8.9-8.3-14.1-11.5h-39.9v11.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.1,34.6h63.1c-2.6-4.1-5.7-8-9.1-11.5h-54v11.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.1,46.1h69.1c-1.7-4-3.7-7.9-6.1-11.5h-63.1v11.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.1,57.6h72.9c-.9-4-2.2-7.8-3.7-11.5h-69.1v11.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.1,69.2h74.7c-.3-3.9-.9-7.8-1.8-11.5h-72.9v11.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.8,69.2h-74.7v5.8H.2c0,1.9,0,3.8.2,5.7h149.3c.1-1.9.2-3.8.2-5.7s-.1-3.9-.2-5.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2.2,92.2h145.8c.9-3.7,1.5-7.6,1.8-11.5H.4c.3,3.9.9,7.8,1.8,11.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.9,103.7h138.4c1.5-3.7,2.8-7.5,3.7-11.5H2.2c.9,4,2.2,7.8,3.7,11.5Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.9,115.2h126.4c2.3-3.6,4.3-7.5,6-11.5H5.9c1.7,4,3.7,7.9,6,11.5Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.9,126.7h108.3c3.4-3.5,6.4-7.4,9-11.5H11.9c2.6,4.1,5.7,8,9,11.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.9,138.2h80.3c5.1-3.3,9.8-7.1,14-11.5H20.9c4.2,4.4,8.9,8.2,14,11.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.1,149.9c14.8,0,28.6-4.3,40.2-11.7H34.9c11.6,7.4,25.4,11.7,40.2,11.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.2,11.6c-5.2,3.3-9.9,7.1-14.1,11.5-3.4,3.5-6.4,7.4-9.1,11.5-2.3,3.6-4.4,7.5-6.1,11.5-1.5,3.7-2.8,7.5-3.7,11.5-.9,3.7-1.5,7.6-1.8,11.5-.1,1.9-.2,3.9-.2,5.8h74.9V0c-14.7,0-28.3,4.2-39.9,11.5Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "57.6 2.6 58.8 6.3 62.6 6.3 59.5 8.7 60.7 12.5 57.6 10.3 54.5 12.6 55.7 8.7 52.6 6.3 56.4 6.3 57.6 2.6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "67.6 17.6 68.8 21.3 72.6 21.3 69.5 23.7 70.7 27.5 67.6 25.3 64.5 27.6 65.7 23.7 62.6 21.3 66.4 21.3 67.6 17.6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "47.6 17.6 48.8 21.3 52.6 21.3 49.5 23.7 50.7 27.5 47.6 25.3 44.5 27.6 45.7 23.7 42.6 21.3 46.4 21.3 47.6 17.6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "57.6 32.6 58.8 36.2 62.6 36.2 59.5 38.7 60.7 42.5 57.6 40.2 54.5 42.5 55.7 38.7 52.6 36.2 56.4 36.2 57.6 32.6"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "37.6 32.6 38.8 36.2 42.6 36.2 39.5 38.7 40.7 42.5 37.6 40.2 34.6 42.5 35.7 38.7 32.6 36.2 36.5 36.2 37.6 32.6"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "17.7 32.6 18.8 36.2 22.7 36.2 19.6 38.7 20.7 42.5 17.7 40.2 14.6 42.5 15.8 38.7 12.7 36.2 16.5 36.2 17.7 32.6"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "67.6 47.5 68.8 51.2 72.6 51.2 69.5 53.7 70.7 57.5 67.6 55.2 64.5 57.5 65.7 53.7 62.6 51.2 66.4 51.2 67.6 47.5"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "47.6 47.5 48.8 51.2 52.6 51.2 49.5 53.7 50.7 57.5 47.6 55.2 44.5 57.5 45.7 53.7 42.6 51.2 46.4 51.2 47.6 47.5"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "27.6 47.5 28.8 51.2 32.6 51.2 29.6 53.7 30.7 57.5 27.6 55.2 24.6 57.5 25.7 53.7 22.7 51.2 26.5 51.2 27.6 47.5"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "57.6 62.5 58.8 66.2 62.6 66.2 59.5 68.7 60.7 72.4 57.6 70.2 54.5 72.5 55.7 68.7 52.6 66.2 56.4 66.2 57.6 62.5"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "37.6 62.5 38.8 66.2 42.6 66.2 39.5 68.7 40.7 72.4 37.6 70.2 34.6 72.5 35.7 68.7 32.6 66.2 36.5 66.2 37.6 62.5"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "17.7 62.5 18.8 66.2 22.7 66.2 19.6 68.7 20.7 72.4 17.7 70.2 14.6 72.5 15.8 68.7 12.7 66.2 16.5 66.2 17.7 62.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.6,27.6l3.1-2.3,3.1,2.2-1.2-3.8,3.1-2.4h-3.8l-1.2-3.7-1.2,3.7h-3.6s0,0-.1.1l2.9,2.3-1.2,3.8Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.6,57.5l3.1-2.3,3.1,2.2-1.2-3.8,3.1-2.4h-3.8l-1.2-3.7-1.2,3.7h-2.4c0,.3-.2.6-.3.9l2,1.6-1.2,3.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaFlag);
export default __webpack_public_path__ + "static/media/USAFlag.31c46540d733173ce3379b52589b6e2f.svg";
export { ForwardRef as ReactComponent };